import { NextWebVitalsMetric } from 'next/app';

declare global {
  interface Window {
    dataLayer: any[],
  }
}

export interface TrackingEvent {
  [key: string]: any,
}

function pushToDataLayer(event: string, params: TrackingEvent, eventCallback?: () => void, eventTimeout?: number) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...params,
      eventCallback,
      eventTimeout,
    });
  }
}

export async function sendEvent<T extends TrackingEvent>(event: string, params: T): Promise<void> {
  return new Promise<void>((resolve) => {
    let isResolved = false;

    const proceed = () => {
      if (!isResolved) {
        isResolved = true;
        resolve();
      }
    };
    setTimeout(proceed, 500);
    pushToDataLayer(event, { eventModel: params }, proceed, 2000);
  });
}

export function trackCoreVitals(metric: NextWebVitalsMetric) {
  const {
    id,
    name,
    label,
    startTime,
    value,
  } = metric;

  pushToDataLayer(name, {
    label,
    id,
    value,
    startTime,
  });
}
